import * as XLSX from "xlsx";
import FSaver from "file-saver/dist/FileSaver";

export const saveExcelFile = (props) => {

    if (!props) return

    const {
        data= [],
        name=`Report_${(new Date()).toDateString()}`,
        description='Отчет'
    } = props

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileName=`${name}.xlsx`;

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, description.substring(0,31), true);
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const sData = new Blob([excelBuffer], {type: fileType});
    FSaver.saveAs(sData, fileName);
}